import React from 'react';
import { Link } from 'react-router-dom';
import { ActivationCard } from './ActivationCard';

interface CancelledScreenProps {
  reason?: string | null;
  title?: string;
  defaultReason?: string;
}

export const CancelledScreen: React.FC<CancelledScreenProps> = ({
  reason,
  title = 'Registration Cancelled',
  defaultReason = 'The RFID registration was cancelled by the user on the device.',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-user-times text-danger" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <p className="text-muted mb-4">{reason || defaultReason}</p>
      <div className="alert alert-warning" role="alert">
        <i className="fas fa-exclamation-triangle me-2"></i>
        If this was unexpected, please contact your administrator.
      </div>
      <Link to="/login" className="btn btn-primary w-100">
        <i className="fas fa-sign-in-alt me-2"></i>
        Go to Login
      </Link>
    </div>
  </ActivationCard>
);
